export default __webpack_public_path__ + "static/media/GLTD-class-b.8d1b84cc.png";